import { Theme } from '@mui/material';

export const TabCardRadius = '8px';

// The selected tab is styled to look like a raised card that merges into the white
// content panel below it: it gets its own top-rounded border on all sides but the
// bottom, drawn on top (position + zIndex) of the neighboring tab's divider and
// overlapping 1px into the tab bar's own bottom border via a negative margin.
// MUI's Tabs scroller clips overflow by default (to hide scroll arrows), which would
// otherwise clip that 1px overlap and leave a sliver of visible border under the
// selected tab — hence the `!important` override.
export const getTabBarSx = (theme: Theme) => ({
  '& .MuiTab-root': {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  '& .MuiTab-root:has(+ .Mui-selected)': {
    borderRight: 'none',
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderBottom: 'none',
    borderTopLeftRadius: TabCardRadius,
    borderTopRightRadius: TabCardRadius,
    marginBottom: '-1px',
    position: 'relative',
    zIndex: 1,
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-scroller': {
    overflow: 'visible !important',
  },
  backgroundColor: theme.palette.action.hover,
  borderBottom: `1px solid ${theme.palette.divider}`,
  overflow: 'visible',
});
